import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-oxford/10 mt-24 bg-linen">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="display-serif text-3xl">
            The Value Realisation Framework
          </div>
          <p className="mt-4 max-w-md text-sm text-charcoal leading-relaxed">
            A body of work by Steve Bird. Diagnostic, review and index for
            boards that intend to convert effort into measurable, durable value.
          </p>
        </div>
        <div>
          <div className="tick-label mb-4">Intellectual Assets</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/framework" className="hover:text-moss" data-testid="footer-framework">The Framework</Link></li>
            <li><Link to="/diagnostic" className="hover:text-moss" data-testid="footer-diagnostic">The Index</Link></li>
            <li><Link to="/board/new" className="hover:text-moss" data-testid="footer-board">Board Session</Link></li>
          </ul>
        </div>
        <div>
          <div className="tick-label mb-4">Steve Bird</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/steve" className="hover:text-moss" data-testid="footer-steve">About</Link></li>
            <li><Link to="/admin/login" className="hover:text-moss" data-testid="footer-admin">Admin</Link></li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 border-t border-oxford/10 flex flex-col md:flex-row justify-between gap-2 text-[11px] tracking-widest uppercase text-charcoal/70">
        <span>© {new Date().getFullYear()} Steve Bird · valuerealisation.co.uk</span>
        <span>An idea, applied.</span>
      </div>
    </footer>
  );
}
